<template>
  <div v-if="!loadingSubmitted">
    <div class="q-pa-sm row q-gutter-sm justify-center">
      <q-card class="my-card justify-center" flat>
        <q-card-section v-if="edit && place">
          <place-card :name="placeName" :id="uid" :logo="logoUrl" :pointsToPerk="place.pointsToPerk" />
        </q-card-section>
        <q-card-section v-else>
          <h4>Add your stabilishment</h4>
          <p class="text-subtitle2" >Add your store to start scanning your customer's codes</p>
        </q-card-section>
        <q-card-section v-if="!loadingSubmitted">
          <q-form
            class="q-gutter-md"
          >
            <q-input
              outlined
              square
              color="secondary"
              type="text"
              required
              v-model="placeName"
              minlength="3"
              label="Name of your store*"
              hint="i.e.: Aussie Cafe"
              lazy-rules
              :rules="[ val => val && val.length > 0 || 'Please type something']"
            />
            <q-file 
              outlined
              square
              color="secondary" 
              bottom-slots
              v-model="logo"
              clearable
              accept=".jpg, .gif, .jpeg, .png"
              label="Logo (Opcional)"
              counter
              :rules="[val => !val || val && val.size < 1024000 || 'Please upload an image smaller than 1Mb.']"
            >
              <template v-slot:hint>
                Choose a square image file. Min 100px, max 1000px. JPG, GIF and PNG are accepted.
              </template>
            </q-file>


            <address-autocomplete @place="updatePlace" :address="address" :key="addressKey" label="Address"
              :rules="[ val => val && val.length > 0 || 'Please type something']" 
            hint="i.e.: Boulevard One, 123" />
            
            <q-separator color="accent" inset />
            <h6 class="q-my-sm">Perks Configuration</h6>
            <q-input
              outlined
              square
              color="secondary"
              type="text"
              v-model="message"
              label="Promo Message (optional)"
              hint="i.e.: Buy 9 coffees and the 10th is free!"
            />
            <q-item class="row">
              <q-item-section class="col-2">
                <q-item-section side>
                  <q-btn round color="secondary" :disable="perks === 1" @click="perks = perks - 1"  icon="remove" />
              </q-item-section>
              </q-item-section>
              <q-item-section  class="col-8">    
                <q-input
                  v-model.number="perks"
                  label="Points to receive a perk"
                  type="number"    
                  outlined
                  square
                  color="secondary"
                />
              </q-item-section>
              <q-item-section  class="col-2">
                <q-item-section side>
                  <q-btn round color="secondary" @click="perks = perks + 1" icon="add" />
                </q-item-section>
              </q-item-section>
            </q-item>
            <p class="text-subtitle2" v-if="perks">The {{perks + 1}}th purchase/visit will receive a perk.</p>
            <p class="text-subtitle2" v-if="perks">Every time you scan a QrCode, you can define how many points are credited.</p>
            <q-separator color="accent" inset />
            <h6 class="q-my-sm">Terms and Conditions</h6>
            <p class="text-caption q-my-xs">By adding your place you agree with our <a  class="text-primary normal-link" href="/terms-of-use">Terms and Conditions</a> and our <a class="text-primary normal-link" href="/privacy-policy">Privacy Policy</a></p>
            <div class="col-12 col-md-6">
              <q-btn label="Save Business" @click="handleSubmit()" :loading="loadingSubmitted" class="full-width square" size="md" unelevated color="secondary"/>
            </div>
            <q-banner v-if="error" rounded dense class="text-white bg-red">
              {{error}}
              <template v-slot:action>
                <q-btn flat label="Dismiss" @click="error = ''" />
              </template>
            </q-banner>
          </q-form>
        </q-card-section>
        <q-card-section>

        </q-card-section>
      </q-card>
    </div>
  </div>
  <div class="q-pa-md row q-gutter-md justify-center" v-else>
    <Spinner />
  </div>
</template>


<script>
import Spinner from "@/components/Spinner";
import PlaceCard from "@/components/PlaceCard";
import AddressAutocomplete from "@/components/AddressAutocomplete";
import { ref } from "vue";
import router from "@/router";
import { useRoute } from 'vue-router'
import { inject } from 'vue'
import { useStore } from 'vuex';

export default {
  name: "AddPlace",
  components: { Spinner, PlaceCard, AddressAutocomplete },
  setup() {
    const loadingSubmitted = ref(false)
    const placeName = ref('')
    const address = ref('')
    const logo = ref(null)
    const message = ref('')
    const perks = ref(9)
    const uid = ref(false)
    const error = ref('')
    const logoUrl = ref('')
    const edit = ref(false)
    const route = useRoute()
    const id = ref(null)
    const addressObj = ref(null)
    const axios = inject('axios')
    const store = useStore()
    const addressCountry = ref(null)
    const addressDistrict  = ref(null)
    const addressCity = ref(null)
    const addressStreet = ref(null)
    const addressNumber = ref(null)
    const addressComplement = ref(null)
    const addressNeighborhood = ref(null)
    const addressLat = ref(null)
    const addressLon = ref(null)
    const addressPostcode = ref(null)
    const place = ref(null)
    const addressKey = ref(0)

    const updatePlace = (place) => {
      address.value = place.formatted_address
      addressCountry.value = getAddressValue(place.address_components, 'country')
      addressDistrict.value = getAddressValue(place.address_components, 'administrative_area_level_1')
      addressCity.value = getAddressValue(place.address_components, 'administrative_area_level_2')
      addressStreet.value = getAddressValue(place.address_components, 'route')
      addressNumber.value = getAddressValue(place.address_components, 'street_number')
      addressComplement.value = getAddressValue(place.address_components, 'administrative_area_level_2')
      addressNeighborhood.value = place.vicinity
      addressLat.value = place.geometry.location.lat()
      addressLon.value = place.geometry.location.lat()
      addressPostcode.value = getAddressValue(place.address_components, 'postal_code')
      addressObj.value = {
        formatted_address: place.formatted_address,
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
        place_id: place.place_id // ID do lugar no maps, não o interno
      }
    }

    const getAddressValue = (array, key) => {
      let filter = array.filter(e => {
        if (e.types.includes(key)) return e
      })

      if (filter.length > 0) return filter[0].short_name
      return ''
    }

    const editVerify = () => {
      id.value = route.params.id
      if (id.value) {
        edit.value = true
        axios.get(`${process.env.VUE_APP_URL}/places/${id.value}`)
          .then(resp => {
            place.value = resp.data
            placeName.value = place.value.name
            logoUrl.value = place.value.logo
            address.value = place.value.addressStreet + ' - ' + place.value.addressNumber + ', ' + place.value.addressNeighborhood + ' - ' + place.value.addressCity + ', ' + place.value.addressDistrict + ' - ' + place.value.addressCountry
            perks.value = place.value.pointsToPerk
            message.value = place.value.promoMessage
            addressCountry.value = place.value.addressCountry
            addressDistrict.value = place.value.addressDistrict
            addressCity.value = place.value.addressCity
            addressStreet.value = place.value.addressStreet
            addressNumber.value = place.value.addressNumber
            addressComplement.value = place.value.addressComplement
            addressNeighborhood.value = place.value.addressNeighborhood
            addressLat.value = place.value.addressLat
            addressLon.value = place.value.addressLon
            addressPostcode.value = place.value.addressPostcode
            addressKey.value += 1
          })
          .catch(err => {
            edit.value = false
            error.value = 'An error ocurred when login user. Wait a few moments and try again.'
          })
      } else {
        edit.value = false
      }
    }

    const uploadLogo = () => { // faz o upload da logo
      const fileName = placeName.value.toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '')
      
      let formData = new FormData();
      formData.append('file', logo.value, fileName);

      return axios.post(`${process.env.VUE_APP_URL}/media_objects`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      
    }

    const handleSubmit = () => {
      store.dispatch('verifyLogged')
      .then(resp => {
        if (logo.value) {
          uploadLogo().then((resp) => {
            logoUrl.value = '/media_objects/' + resp.data.id
            error.value = null
            savePlace()
          })
          .catch(err => {
            error.value = 'Error when uploading logo.'
            if (err.response.data) {
              error.value += " " + err.response.data.detail
            }
            // debugger
          })
        } else {
          savePlace()
        }
      })
      .catch(error => {
        store.commit('setUser', null)
        store.commit('setClearHistory')
        store.commit('clearPlace')
        router.push('/')
      })
    }
    const savePlace = async () => {
      loadingSubmitted.value = true
      let request
      let data = {
        owner: store.getters.stateUser.iri,
        name: placeName.value,
        addressCountry: addressCountry.value,
        addressDistrict: addressDistrict.value,
        addressCity: addressCity.value,
        addressStreet: addressStreet.value,
        addressNumber: addressNumber.value,
        addressComplement: addressComplement.value,
        addressNeighborhood: addressNeighborhood.value,
        addressLat: addressLat.value,
        addressLon: addressLon.value,
        addressPostcode: addressPostcode.value,
        pointsToPerk: perks.value,
        promoMessage: message.value
      };
      if (logo.value) {
        data = {
          ...data,
          logo: logoUrl.value
        }
      }
      if (edit.value) {
        request = axios.put(`${process.env.VUE_APP_URL}/places/${id.value}`, data)
      } else {
        request = axios.post(`${process.env.VUE_APP_URL}/places`, data)
      }
      request.then((resp) => {
        router.push({name: 'Merchant_Scan'})
      })
      .catch((err) => {
        addressKey.value += 1
        if (err.response) {
          // Request made and server responded
          error.value = err.response.data.detail
          gtag('event', 'exception', {'fatal': true, 'description': err.response.data.detail, 'method': 'AddPlace.savePlace'})
        } else {
          // Something happened in setting up the request that triggered an Error
          error.value = err.message
        }

        loadingSubmitted.value = false
      })
    }

    store.dispatch('verifyLogged')
    .then(resp => {
      uid.value = store.getters.stateUser.id

      editVerify()
    })
    .catch(error => {
      store.commit('setUser', null)
      store.commit('setClearHistory')
      store.commit('clearPlace')
      router.push('/')
    })
    
    return {handleSubmit, error, placeName, logo, address , message, perks, loadingSubmitted, edit, logoUrl, uid, place, updatePlace, addressKey}
  },
  
}
</script>

<style scoped>

</style>